/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { IdmeTokenResponse } from '../models/IdmeTokenResponse';
import type { RefreshForBearerTokenRequestDto } from '../models/RefreshForBearerTokenRequestDto';
import type { TokenRequestDto } from '../models/TokenRequestDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { request as __request } from '../core/request';

export class IdmeAuthService {

    /**
     * @param requestBody
     * @returns IdmeTokenResponse Successfully exchanged authorization code for token.
     * @throws ApiError
     */
    public static idmeAuthControllerExchangeCodeForToken(
        requestBody: TokenRequestDto,
    ): CancelablePromise<IdmeTokenResponse> {
        return __request({
            method: 'POST',
            path: `/auth/idme/token`,
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Failed to exchange code for token.`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns IdmeTokenResponse Successfully obtained a new bearer token by refresh token.
     * @throws ApiError
     */
    public static idmeAuthControllerExchangeRefreshForBearerToken(
        requestBody: RefreshForBearerTokenRequestDto,
    ): CancelablePromise<IdmeTokenResponse> {
        return __request({
            method: 'POST',
            path: `/auth/idme/refresh`,
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Failed to obtain a new bearer token by refresh token.`,
            },
        });
    }

}